import { useState, useEffect } from 'react';
import axios from 'axios';

type ProductCategory = {
  _id: string;
  name: string;
  subcategories: { name: string; products: any[] }[];
  products: any[];
};


const useProducts = () => {
  const [products, setProducts] = useState<ProductCategory[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const apiUrl = process.env.REACT_APP_API_URL;
  const url = `${apiUrl}/api/products`;

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get(`${url}/all`);
        setProducts(response.data); // assuming response.data contains the product data
      } catch (err: any) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, [url]); // Empty dependency array means it only runs on component mount

  return { products, loading, error };
};

export default useProducts;
